import React from 'react';
import moment from 'moment';

import { env } from '~/commons/config';
import ListResource from './ListResource.jsx';

const api = '/api/core/roles';

const ListRoles = () => (
  <ListResource
    {...{
      searchable: true,
      filter: {},
      api,
      sort: { name: 1 },
      actions: {},
      cols: [
        { key: 'name', sortable: true, children: 'Name' },
        {
          key: 'createdBy.name.full.en',
          children: 'Created By',
          sortable: true,
        },
        {
          key: 'createdAt',
          sortable: true,
          getter: (v) => moment(v).format(env.f.d),
        },
      ],
    }}
  />
);

export default ListRoles;
